"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupSearchReducer = exports.groupSearchActions = exports.TYPES = exports.PERMISSION_KEYS = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'groupSearch';
const PERMISSION_KEYS = exports.PERMISSION_KEYS = {
  NALLOW_OWN: 'nallow_own'
};

// アクションタイプ
const TYPES = exports.TYPES = {
  SET_CONTENT: PREFIX + 'SetContent',
  SET_GROUP_NM: PREFIX + 'SetGroupNm',
  SET_LIST: PREFIX + 'SetList',
  SET_ADMIN_LIST: PREFIX + 'SetAdminList',
  SET_USERS: PREFIX + 'SetUsers',
  SET_ADMINS: PREFIX + 'SetAdmins',
  SET_PERMISSION: PREFIX + 'SetPermission',
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  GO_MAIN: PREFIX + 'GoMain',
  GO_UPDATE: PREFIX + 'GoUpdate',
  GO_DELETE: PREFIX + 'GoDelete',
  GO_RESULT: PREFIX + 'GoResult',
  RESET_PAGING: PREFIX + 'ResetPaging',
  CHANGE_PAGE: PREFIX + 'ChangePage',
  CHANGE_PAGE_ADMIN: PREFIX + 'ChangePageAdmin',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_VIEW_NUM_ADMIN: PREFIX + 'ChangeViewNumAdmin',
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  CHANGE_SHOW_ALL_ADMIN: PREFIX + 'ChangeShowAllAdmin',
  CHANGE_CHECKED: PREFIX + 'ChangeChecked',
  CHANGE_CHECKED_ADMIN: PREFIX + 'ChangeCheckedAdmin',
  CHANGE_CHECKED_ALL: PREFIX + 'ChangeCheckedAll',
  CHANGE_CHECKED_ALL_ADMIN: PREFIX + 'ChangeCheckedAllAdmin',
  DELETE_CHECKED: PREFIX + 'DeleteChecked',
  DELETE_CHECKED_ADMIN: PREFIX + 'DeleteCheckedAdmin',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  CLEAR: PREFIX + 'Clear'
};

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  UPDATE: 'update',
  DELETE: 'delete',
  RESULT: 'result',
  NOTUSE: 'notuse'
};

// 初期状態
const INIT_STATE = {
  dispContent: '',
  action: '',
  listUser: [],
  listAdmin: [],
  checkedList: {},
  admincheckedList: {},
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  soshikiShowAll: false,
  soshikiShowAllAdmin: false,
  searchConditions: {
    groupNm: ''
  },
  permissions: {
    [PERMISSION_KEYS.NALLOW_OWN]: false
  },
  fixedConditions: {
    groupNm: ''
  },
  searchResult: [],
  groupInfo: {
    groupNm: '',
    groupNo: null
  },
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  pagingAdmin: {
    viewNum: 50,
    currentPage: 0
  },
  search: false
};
const groupSearchActions = exports.groupSearchActions = (0, _reduxActions.createActions)({
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_RESULT]: function () {
    return {
      action: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_GROUP_NM]: function () {
    return {
      groupNm: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_LIST]: function () {
    return {
      listUser: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ADMIN_LIST]: function () {
    return {
      listAdmin: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_USERS]: function () {
    return {
      users: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ADMINS]: function () {
    return {
      admins: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_PERMISSION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      groupInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_DELETE]: function () {
    return {
      groupInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE_ADMIN]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM_ADMIN]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL_ADMIN]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CHECKED]: function () {
    return {
      id: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CHECKED_ADMIN]: function () {
    return {
      id: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CHECKED_ALL]: function () {
    return {
      checked: arguments.length <= 0 ? undefined : arguments[0],
      getId: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_CHECKED_ALL_ADMIN]: function () {
    return {
      checked: arguments.length <= 0 ? undefined : arguments[0],
      getId: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_PAGING, TYPES.DELETE_CHECKED, TYPES.DELETE_CHECKED_ADMIN, TYPES.CLEAR);
const groupSearchReducer = exports.groupSearchReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.GO_RESULT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.RESULT,
      action: action.payload.action
    });
  },
  [TYPES.SET_GROUP_NM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      groupInfo: _objectSpread(_objectSpread({}, state.groupInfo), {}, {
        groupNm: action.payload.groupNm
      })
    });
  },
  [TYPES.SET_LIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      listUser: [...action.payload.listUser]
    });
  },
  [TYPES.SET_ADMIN_LIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      listAdmin: [...action.payload.listAdmin]
    });
  },
  [TYPES.SET_USERS]: (state, action) => {
    const newCheckedList = {};
    if (action.payload.users) {
      action.payload.users.forEach(user => {
        newCheckedList[user.kaishaCd + user.shainId] = false;
      });
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      listUser: [...action.payload.users],
      checkedList: _objectSpread({}, newCheckedList)
    });
  },
  [TYPES.SET_ADMINS]: (state, action) => {
    const newCheckedAdminList = {};
    if (action.payload.admins) {
      action.payload.admins.forEach(admin => {
        newCheckedAdminList[admin.kaishaCd + admin.shainId] = false;
      });
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      listAdmin: [...action.payload.admins],
      admincheckedList: _objectSpread({}, newCheckedAdminList)
    });
  },
  [TYPES.SET_PERMISSION]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      permissions: _objectSpread(_objectSpread({}, state.permissions), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.CHANGE_CHECKED]: (state, action) => {
    const {
      id
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      checkedList: _objectSpread(_objectSpread({}, state.checkedList), {}, {
        [id]: !state.checkedList[id]
      })
    });
  },
  [TYPES.CHANGE_CHECKED_ADMIN]: (state, action) => {
    const {
      id
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      admincheckedList: _objectSpread(_objectSpread({}, state.admincheckedList), {}, {
        [id]: !state.admincheckedList[id]
      })
    });
  },
  [TYPES.CHANGE_CHECKED_ALL]: (state, action) => {
    let tagetList = state.listUser.slice(state.paging.currentPage * state.paging.viewNum, state.paging.currentPage * state.paging.viewNum + state.paging.viewNum);
    let newListState = _objectSpread({}, state.checkedList);
    tagetList.forEach(data => {
      newListState[action.payload.getId(data)] = action.payload.checked;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      checkedList: _objectSpread({}, newListState)
    });
  },
  [TYPES.CHANGE_CHECKED_ALL_ADMIN]: (state, action) => {
    let tagetList = state.listAdmin.slice(state.pagingAdmin.currentPage * state.pagingAdmin.viewNum, state.pagingAdmin.currentPage * state.pagingAdmin.viewNum + state.pagingAdmin.viewNum);
    let newListState = _objectSpread({}, state.admincheckedList);
    tagetList.forEach(data => {
      newListState[action.payload.getId(data)] = action.payload.checked;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      admincheckedList: _objectSpread({}, newListState)
    });
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    fixedConditions: _objectSpread({}, state.searchConditions),
    search: false
  }),
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    groupInfo: _objectSpread({}, action.payload.groupInfo),
    dispContent: CONTENTS.UPDATE
  }),
  [TYPES.GO_DELETE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    groupInfo: _objectSpread({}, action.payload.groupInfo),
    dispContent: CONTENTS.DELETE
  }),
  [TYPES.GO_MAIN]: (state, action) => {
    let searchConditions;
    if (action.payload.search) {
      searchConditions = state.fixedConditions;
    } else {
      searchConditions = state.searchConditions;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.MAIN,
      search: action.payload.search,
      searchConditions
    });
  },
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_PAGE_ADMIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    pagingAdmin: _objectSpread(_objectSpread({}, state.pagingAdmin), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_VIEW_NUM_ADMIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    pagingAdmin: _objectSpread(_objectSpread({}, state.pagingAdmin), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.DELETE_CHECKED]: state => {
    const newList = state.listUser.filter(data => {
      let checkedKey = data.kaishaCd + data.shainId;
      return !state.checkedList[checkedKey];
    });
    const newCheckedList = {};
    newList.forEach(user => {
      newCheckedList[user.kaishaCd + user.shainId] = false;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listUser: [...newList],
      checkedList: _objectSpread({}, newCheckedList)
    });
  },
  [TYPES.DELETE_CHECKED_ADMIN]: state => {
    const newList = state.listAdmin.filter(data => {
      let checkedKey = data.kaishaCd + data.shainId;
      return !state.admincheckedList[checkedKey];
    });
    const newCheckedList = {};
    newList.forEach(user => {
      newCheckedList[user.kaishaCd + user.shainId] = false;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listAdmin: [...newList],
      admincheckedList: _objectSpread({}, newCheckedList)
    });
  },
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    const newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      soshikiShowAll: action.payload.showAll
    });
  },
  [TYPES.CHANGE_SHOW_ALL_ADMIN]: (state, action) => {
    const newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      soshikiShowAllAdmin: action.payload.showAll
    });
  },
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);